<template>
  <div class="cadre">
    <h3>Planning de livraison pour {{ formatTitre(currentDate) }}</h3>
    <br/>
    <div>
      <FullCalendar :options="calendarOptions"/>
    </div>
  </div>
  <br/>
  <div class="cadre">
    <div class="h3_remove">
      <h3>Commande prévue le {{ livraison.dateLivraison ? format(livraison.dateLivraison) : '' }}</h3>

      <div v-if="livraison.id">
        <div class="tab_outils">
          <a v-on:click="printLivraison()">
            <i class="material-icons"
               style="font-size:20px;color:grey; display: flex;justify-content: flex-end">print</i>
          </a>
          <a v-on:click="deleteLivraison()">
            <i class="material-icons" style="font-size:20px;color:red">delete</i>
          </a>
        </div>
      </div>
    </div>
    <table>
      <thead>
      <tr>
        <th>Horaire</th>
        <th>Nom</th>
        <th>Quantité</th>
        <th>Longueur</th>
        <th>Localité</th>
        <th>Commentaire</th>
        <th>
          <div class="tab_outils">
            <div v-if="livraison.id">
              <a data-bs-toggle="modal" data-bs-target="#modalLivraisonAddCommande"
                 v-on:click="LivraisonAddCommande(livraison.id)">
                <i class="material-icons"
                   style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
              </a>
            </div>
          </div>
        </th>
      </tr>

      </thead>
      <draggable v-if="livraison.commande && livraison.commande.length" v-model="livraison.commande" tag="tbody"
                 item-key="id">
        <template #item="{ element: commande, index }">
          <tr :key="commande.id">
            <td>{{ commande.trancheHoraire }}</td>
            <td>{{ commande.identite.nom || commande.identite.societe }}</td>
            <td>{{ commande.quantiteBois }}</td>
            <td>{{ commande.longueurBois }}</td>
            <td>{{ commande.identite.adresse.localite }}</td>
            <td>{{ commande.notes }}</td>
            <td>
              <div class="tab_outils">
                <div>
                  <a data-bs-toggle="modal" data-bs-target="#modalEditCommande"
                     @click="editCommande(commande.id, commande.identite.id)">
                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                  </a>
                </div>
                <div>
                  <a @click="removeCommande(index)">
                    <i class="material-icons" style="font-size:20px;color:red">delete</i>
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </draggable>
      <tfoot v-if="livraison.commande && livraison.commande.length">
      <tr>
        <td></td>
        <td>Total :</td>
        <td>{{ totalStocks }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tfoot>
      <tfoot v-else>
      <tr>
        <td colspan="7" class="emptyTableMessage">Aucune Livraison trouvée</td>
      </tr>
      </tfoot>
    </table>
  </div>

  <CommandeEdit :params="{ id: commandeEditId, idIdentite: clienEditId }" @saved="getLivraison(livraison.id)"/>
  <LivraisonEdit :params="{ date: livraisonDateEdit }" @saved="fetchLivraison()"/>
  <LivraisonAddCommande :params="{ id: livraisonAddId }" @saved="getLivraison(livraison.id)"/>

</template>

<script>
import Axios from '@/services/axios.service';
import DateFormatService from '@/services/dateFormat.service';
import ModalEdition from '../../../../components/ModalEdition.vue';
import ModalImpression from '../../../../components/ModalImpression.vue';

import CommandeEdit from '../../gestionCommande/commande/CommandeEdit.vue';
import LivraisonAddCommande from './LivraisonAddCommande.vue';
import LivraisonEdit from './LivraisonCreate.vue';

import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/vue3';

import draggable from 'vuedraggable';

import {generateFicheLivraison} from "../../../Document/generationFicheLivraison";

export default {
  name: 'Planningindex',
  mixins: [DateFormatService],
  components: {
    ModalEdition, ModalImpression, FullCalendar, CommandeEdit, LivraisonEdit, LivraisonAddCommande, draggable
  },
  data() {
    return {
      allLivraison: [],
      livraison: {},

      livraisonDateEdit: null,
      livraisonAddId: null,
      commandeEditId: null,
      clienEditId: null,
      currentDate: null,

      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locale: 'fr',
        height: '470px',
        dateClick: this.onDateClick,
        firstDay: 1,
        fixedWeekCount: false,
        datesSet: this.updateTitle,
        headerToolbar: {
          left: '',
          center: '',
          right: ''
        },
        footerToolbar: {
          left: '',
          center: '',
          right: 'prev,next'
        },
        events: [],
        eventClick: (info) => this.getLivraison(info.event.id)
      }
    };
  },
  mounted() {
    this.fetchLivraison();
  },
  methods: {
    fetchLivraison() {
      Axios.get('/livraison/statut/ACTIF')
          .then(res => {
            this.allLivraison = res.data;

            const events = this.allLivraison.map(livraison => {
              const isPast = new Date(livraison.dateLivraison).getTime() <= new Date().getTime();
              return {
                id: livraison.id.toString(),
                title: `Livraison (${livraison.commande?.length || 0})`,
                start: livraison.dateLivraison,
                allDay: true,
                color: isPast ? 'rgb(20,150,23)' : 'rgba(237, 87, 62, 1)'
              };
            });
            this.calendarOptions = {...this.calendarOptions, events};
          })
          .catch(err => {
            console.error('Erreur lors du chargement des livraison :', err);
          });
    },
    getLivraison(id) {
      Axios.get('/Livraison/' + id)
          .then((res) => {
            this.livraison = res.data

            this.livraison.commande.sort((a, b) => {
              const getStartHour = (horaire) => {
                if (!horaire) return 0;
                // Récupère tout ce qui est avant le 'h' et convertit en nombre
                return parseInt(horaire.split('h')[0], 10);
              };

              return getStartHour(a.trancheHoraire) - getStartHour(b.trancheHoraire);
            });
          }).catch(err => {
        console.error('Erreur lors de la livraison :', err);
      });
    },
    deleteLivraison() {
      if (this.livraison.id) {
        if (!this.livraison.commande || this.livraison.commande.length === 0) {
          Axios.delete('/livraison/' + this.livraison.id)
              .then(response => {
                if (response.status == 200) {
                  this.livraison = {};
                  this.fetchLivraison();
                }
              })
              .catch(err => {
                alert(err)
              })
        } else {
          alert("Des commandes sont toujours dans le planning du jour")
        }
      }
    },
    editCommande(id, identiteId) {
      this.commandeEditId = id;
      this.clienEditId = identiteId;
    },
    LivraisonAddCommande(id) {
      this.livraisonAddId = id;
    },
    removeCommande(index) {
      const commande = this.livraison.commande[index];

      Axios.patch(`/commande/${commande.id}/removeLivraison`)
          .then(response => {
            if (response.status === 200) {
              this.livraison.commande.splice(index, 1);
            }
          })
          .catch(err => {
            console.error("Erreur lors de la suppression du lien avec la livraison :", err);
          });
    },
    updateTitle(info) {
      this.currentDate = info.view.currentStart;
    },
    formatTitre(date) {
      if (!date) return '';
      const options = {month: 'long', year: 'numeric'};
      const texte = date.toLocaleDateString('fr-FR', options);
      return texte.charAt(0).toUpperCase() + texte.slice(1);
    },
    onDateClick(info) {
      this.livraisonDateEdit = info.dateStr;
      const modal = new bootstrap.Modal(document.getElementById('modalCreateLivraison'));
      modal.show();
    },
    async printLivraison() {
      if (this.livraison.commande)
        await generateFicheLivraison(this.livraison)
    },
  },
  computed: {
    totalStocks() {
      return this.livraison.commande.reduce((sum, co) => sum + Number(co.quantiteBois), 0);
    }
  },
}
</script>

<style>
.fc-daygrid-day-number,
.fc-col-header-cell-cushion {
  color: black;
  text-decoration: none;
}

.fc-day-today {
  background-color: #143D60 !important;
  color: rgba(237, 87, 62, 1) !important;
  font-weight: bold;
}

.fc-day-today .fc-daygrid-day-number {
  color: rgba(237, 87, 62, 1) !important;
  font-weight: bold;
}

.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  display: none !important;
}

.fc-footer-toolbar {
  height: auto !important;
  /* Permet hauteur naturelle */
  min-height: 0 !important;
  padding-top: 2px !important;
  /* Réduis padding haut */
  padding-bottom: 2px !important;
  /* Réduis padding bas */
  margin: 0 !important;
  line-height: 1 !important;
  /* Resserre la hauteur de ligne */
}

.fc-footer-toolbar .fc-toolbar-chunk {
  margin: 0 !important;
  /* Supprime marges internes */
  padding: 0 !important;
}

.fc-footer-toolbar button {
  padding: 2px 6px !important;
  /* Ajuste padding boutons pour compacité */
  font-size: 0.85rem !important;
  /* Rends les boutons un peu plus petits */
}
</style>